import { UseFormReturn, FieldValues } from "react-hook-form";
import { baseUrl, translate, postKmsData } from "@kaltura/mediaspace-shared-utils";
import { useToastsContext } from "@kaltura/mediaspace-shared-contexts";

/**
 * custom hook to hold tabs form-handling
 * used when tabs has a defined form with a submit button.
 */
export function useTabForm({
    categoryId,
    saveUrl,
    methods,
}: {
    categoryId: string;
    saveUrl: string;
    methods: UseFormReturn<FieldValues, any, FieldValues>;
}) {
    const { showToast } = useToastsContext();

    const handleSubmit = async (data: FieldValues) => {
        try {
            const { success, message, errors } = await postKmsData(
                `${baseUrl}${saveUrl}`,
                { id: categoryId, data: data }
            );

            // show toast messages
            message && showToast({ severity: success ? "success" : "error", message: message });

            // show validation errors
            if (errors) {
                errors.forEach((error: { field: string; message: string }) => {
                    methods.setError(error.field, { message: error.message });
                });
            }

            // reset the form isDirty
            methods.reset(data, { keepErrors: true, keepIsValid: true });
        }
        catch (e) {
            showToast({ severity: "error", message: translate("Error while saving category") });
        }
    };

    return handleSubmit;
}
